import React from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import { calculateAge } from '../../../utils'

const ParentOverviewCard = ({parent}) => {
  return (
    <aside className='w-full overflow-hidden bg-white'>
        <div className='mx-auto flex h-[220px] w-full items-center justify-center bg-gray-50' style={{
        backgroundImage: `url(" ${parent?.avatar} ")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'none'
        }}>
            {(!parent?.avatar || parent?.avatar === '') &&
                <CameraIcon className={`w-8 h-8 text-gray-200`} />
            }
        </div>
        <div className='py-5'>
            <p className='font-space-grotesk text-base font-semibold text-gray-900'>{parent?.fullName || `${parent?.firstName || ''}${parent?.otherNames ? ` ${parent.otherNames.charAt(0)}.` : ''} ${parent?.lastName || ''}`}</p>
            <p className='mt-1 break-all text-sm text-vcm-dark-gray'>{parent?.email || <span className='text-gray-400'>No email address</span>}</p>

            <div className='mt-5 rounded-lg bg-vcm-light-purple/20 p-3'>
                <p className='text-xs text-vcm-dark-gray'>Occupation</p>
                <p className='mt-1 text-sm font-medium text-gray-900'>{parent?.occupation || <span className='text-gray-400'>Not provided</span>}</p>
            </div>

            <div className='mt-3 grid grid-cols-2 gap-3'>
                <div className='rounded-lg border border-gray-100 p-3'>
                    <p className='text-xs text-vcm-dark-gray'>Gender</p>
                    <p className='mt-1 capitalize text-sm font-medium text-gray-900'>{parent?.gender?.toLowerCase() || 'Not provided'}</p>
                </div>
                <div className='rounded-lg border border-gray-100 p-3'>
                    <p className='text-xs text-vcm-dark-gray'>Age</p>
                    <p className='mt-1 font-space-grotesk text-sm font-medium text-gray-900'>{parent?.dob ? calculateAge(parent.dob) : 'Not provided'}</p>
                </div>
            </div>

            <div className='mt-3 border-t border-gray-100 pt-4'>
                <p className='text-xs text-vcm-dark-gray'>Phone</p>
                <p className='mt-1 text-sm font-medium text-gray-900'>{parent?.phone || <span className='text-gray-400'>Not provided</span>}</p>
            </div>

            {parent?.altPhone && (
                <div className='mt-3'>
                    <p className='text-xs text-vcm-dark-gray'>Alternate phone</p>
                    <p className='mt-1 text-sm font-medium text-gray-900'>{parent.altPhone || <span className='text-gray-400'>Not provided</span>}</p>
                </div>
            )}

            {parent?.students && parent?.students.length > 0 && (
                <div className='mt-5 rounded-lg bg-gray-50 p-3'>
                    <p className='text-xs text-vcm-dark-gray'>Linked students</p>
                    <p className='mt-1 font-space-grotesk text-2xl font-bold text-vcm-purple'>{parent.students.length}</p>
                </div>
            )}
        </div>
    </aside>
  )
}

export default ParentOverviewCard
